import { Formik, Form } from 'formik';
import { useCallback } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { MdArrowBack } from 'react-icons/md';
import { FiLock, FiMail, FiUser } from 'react-icons/fi';
import { FaSpotify } from 'react-icons/fa';
import { toast } from 'react-toastify';
import * as yup from 'yup';
import { useTheme, DefaultTheme } from 'styled-components';
import { Button } from '../../../components/Button';
import { Input } from '../../../components/Input';
import { useAuth } from '../../../hooks/auth';

const data = {
  email: '',
  password: '',
  name: '',
};

const schema = yup.object({
  name: yup.string().required('Digite seu nome'),
  email: yup
    .string()
    .email('Digite um email válido')
    .required('Digite seu email'),
  password: yup.string().required('Digite sua senha'),
});

interface SubmitProps {
  name: string;
  password: string;
  email: string;
}

export const SignUp = () => {
  const theme: DefaultTheme = useTheme();
  const { signIn } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(
    async ({ email, password }: SubmitProps) => {
      try {
        setLoading(true);
        await signIn({
          email,
          password,
        });
      } catch (err: any) {
        if (err.response.data.message) {
          toast.error(err.response.data.message);
          return;
        }
        toast.error('Erro ao realizar login');
      } finally {
        setLoading(false);
      }
    },
    [signIn],
  );

  return (
    <Formik
      initialValues={data}
      validationSchema={schema}
      onSubmit={handleSubmit}
    >
      <Form>
        <h5 className="text-center">
          <FaSpotify
            size={65}
            color={theme.colors.secondary}
            className="mr-2"
          />
        </h5>
        <h4 className="text-center mt-3 mb-3">Crie sua conta</h4>
        <h6>Informe seus dados abaixo para criar sua conta</h6>
        <Input
          type="text"
          name="name"
          placeholder="Nome completo"
          icon={FiUser}
        />

        <Input type="email" name="email" placeholder="Email" icon={FiMail} />

        <Input
          type="password"
          name="password"
          placeholder="Sua senha"
          icon={FiLock}
        />

        <Button
          className="mt-4"
          type="submit"
          background={theme.colors.secondary}
          loading={loading || undefined}
          color="#fff"
        >
          Cadastrar
        </Button>
        <div className="d-flex justify-content-center">
          <Link to="/" className="mt-4 link-redirect">
            <MdArrowBack className="mr-1" />
            Voltar para o login
          </Link>
        </div>
      </Form>
    </Formik>
  );
};
